

import { defineComponent, computed, ref, onMounted, version } from 'vue';
import { Container } from 'inversify';
import { FilterMatchMode, FilterOperator } from 'primevue/api';
import { IServiceSearch } from '../../../search/application/IServiceSearch';
import HelperLoading from '@ilinium/shared/src/common/infrastructure/funciones/HelperLoading';
import { TYPES } from '@ilinium/shared/src/common/domain/types';
import FiltroBusquedaConst from '@ilinium/shared/src/common/domain/constantes/FiltroBusquedaConst';
import { SearchData } from '../../../search/domain/search';
import { IapDataSourceLookUp } from '../../../datasource/domain/iapDataSourceLookUp';
import DataSourceConst from '../functions/dataSourceConst';
import { IapDataSourceField } from '../../../datasource/domain/iapDataSourceField';
import { IapCatalog } from '../../../catalog/domain/iapCatalog';
import CatalogTypeConst from '@ilinium/shared/src/common/domain/constantes/CatalogTypeConst';
import SqlTypesConst from '@ilinium/shared/src/common/domain/constantes/SqlTypesConst';
import HelperCommon from '@ilinium/shared/src/common/infrastructure/funciones/HelperCommon';
import { DropdownChangeEvent } from 'primevue/dropdown';
import { MultiSelectChangeEvent } from 'primevue/multiselect';
import DataSourceComp from '../functions/dataSourceComp';
import { useStore } from 'vuex';
import HelperUtils from '@ilinium/shared/src/common/infrastructure/funciones/HelperUtils';
import ExpressionNomenclatorConst from '../../../expression/domain/const/ExpressionNomenclatorConst';

export default defineComponent({
    name: 'look_up_search_table',
    events: ['update:data', 'change:rowSelected'],
    props: {
        container: {
            type: Object as () => Container
        },
        dataSourceLookUp: {
            type: Object as () => IapDataSourceLookUp,
            default: []
        },

        filterConditions: {
            type: Object as () => SearchData[],
            default: []
        },
        catalogsData: {
            type: Object as () => IapCatalog[],
            default: () => ([])
        },
        colSize: {
        type: Number,
        default: (12)
        }  
    },
    setup(props, { emit }) {

        const inputSearchId = ref();
        const inputSearchDesc = ref();
        const dataSearchFilter = ref<Partial<SearchData>[]>([]);
        const rows = ref();
        const selectedSearch = ref('');
        const fieldsData = ref();
        const selectedColumns = ref();
        const initialColumns = ref();
        const store = useStore();



        const filters = ref({
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
        });

        const columns = computed(() => {

            return Object.keys(rows.value[0]);
        })

        const ColumnName = (fieldName: string): string => {

            var item = lookUpData.value.find(dsf =>
                (dataBase.value + DataSourceConst.DELIMITERFIELDS + dsf.tableName + DataSourceConst.DELIMITERFIELDS + dsf.field) == fieldName)

            if (fieldName == DataSourceConst.LOOKUPID) {
                const id = props.dataSourceLookUp.idFieldLinked;
                const idData = lookUpData.value.find(x => x.id == id);
                return idData?.shortDescription ?? idData?.description ?? idData?.field ?? fieldName;
            }
            else if (fieldName === DataSourceConst.LOOKUPDESC) {
                const description = props.dataSourceLookUp.idFieldDescription;
                const descData = lookUpData.value.find(x => x.id == description);
                return descData?.shortDescription ?? descData?.description ?? descData?.field ?? fieldName;
            }
            else {
                return item?.shortDescription ?? item?.description ?? item?.field ?? fieldName;
            }

        };



        const displayableColumns = (): string[] => {

            let displayableColumns: string[] = [];
            const lookUpFiltered = lookUpData.value.filter(dsf => dsf.id !== props.dataSourceLookUp.idFieldDescription
                && dsf.id !== props.dataSourceLookUp.idFieldLinked);

            lookUpFiltered.forEach(f => {

                var columnName = (dataBase.value + DataSourceConst.DELIMITERFIELDS + f.tableName + DataSourceConst.DELIMITERFIELDS + f.field)
                displayableColumns.push(columnName);

            });

            displayableColumns.push(DataSourceConst.LOOKUPDESC);
            displayableColumns.push(DataSourceConst.LOOKUPID);

            return displayableColumns;
        }


        const initColumns = () => {

            const showColumn = displayableColumns();

            const columns = Object.keys(rows.value[0]).filter(c => showColumn.includes(c)).map(x => ({
                field: x,
                header: ColumnName(x)
            }))

            return columns;


        };




        const dataBase = computed(() => {
            return props.dataSourceLookUp.dataSource.iapDataSourceDataBase?.idBaseDatos;
        })

        const tables = computed(() => {
            return props.dataSourceLookUp.dataSource.iapDataSourceTableAliases;
        })

        const lookUpData = computed(() => {

            let fields: string[] = [];
            let fieldsFormatted: string[] = props.dataSourceLookUp.additionaFieldsOnSearch?.split(',') ?? [];

            fieldsFormatted.forEach(field => {
                let fieldFormatted: string[] = field.split('.');
                if (fieldFormatted.length == 3) {
                    fields.push(fieldFormatted[2]);
                }
            });

            const id = props.dataSourceLookUp.idFieldLinked;
            const description = props.dataSourceLookUp.idFieldDescription;
            fields.push(id);
            fields.push(description);

            return props.dataSourceLookUp.dataSource.iapDataSourceFields.filter(dsf =>
                fields.includes(dsf.id)) as IapDataSourceField[];

        });

        const getCatalogData = (tipoCatalogoId: string) => {

            return props.catalogsData?.filter(x => x.typeId == tipoCatalogoId).sort((a: { order: number; }, b: { order: number; }) => { return a.order - b.order; })
        }

        const isType = (item: IapDataSourceField, tipo: string) => {
            return item.sqlType == tipo;
        };

        const isCatalogType = (item: IapDataSourceField) => {
            return !HelperCommon.isNullOrWhitespace(item.catalogTypeId ?? "")
        };

        const orderColumns = (columns: { field: string, header: string }[]) => {

            const priorityColumn = columns.find(c => c.field == DataSourceConst.LOOKUPDESC);

            return columns.sort((a, b) => {
                return (a === priorityColumn) ? -1 : (b === priorityColumn) ? 1 : 0;
            });

        }


        const removeField = (data: IapDataSourceField) => {

            dataSearchFilter.value = dataSearchFilter.value.filter(x => x.field?.id !== data.id);
            addFieldOnTheList(data);
        }

        const stopPropagateEventDropDown = (event: DropdownChangeEvent | MultiSelectChangeEvent) => {
            event.originalEvent.stopPropagation();
            event.originalEvent.preventDefault();
        }




        const selectField = (event: DropdownChangeEvent) => {
            stopPropagateEventDropDown(event);
            const aux = selectedSearch.value.split(DataSourceConst.DELIMITER)

            lookUpData.value.filter(x => x.tableName == aux[0] && (x.field == aux[1] || x.fieldAlias == aux[1])).forEach(c => {
                dataSearchFilter.value.push({
                    field: c as any,
                    rangeDateTime: {
                        from: null,
                        to: null
                    },
                    rangeValue: {
                        from: null,
                        to: null
                    },
                    filter: FiltroBusquedaConst.FILTROBUSQUEDA_CONTIENE
                } as any)

                //quitamos el campo de la lista
                removeFieldOnTheList(c);
            })

            selectedSearch.value = ''


        }

        const onRowSelect = (event: any) => {


            emit('change:rowSelected', event);

        };

        const fillDataSearchFilters = () => {


            if (lookUpData.value) {

                const claves = lookUpData.value.map(x =>
                ({
                    field: x,
                    filter: FiltroBusquedaConst.FILTROBUSQUEDA_CONTIENE,
                    value: null,
                    valueList: null,
                    valueBool: null,
                    valueNumber: null,
                    valueDateTime: null,
                    rangeValue: null,
                    rangeNumber: null,
                    rangeDateTime: null

                })).filter(x => x.field.id == props.dataSourceLookUp.idFieldDescription);

                claves.forEach(clave => {
                    dataSearchFilter.value.push(clave as any);
                });


            }
        };




        const getData = () => {
            var data = [] as any;

            if (lookUpData.value.length > 0) {
                tables.value.forEach(x => {
                    const aux = {
                        label: x.shortDescription,
                        icon: x.idIcon ?? 'pi pi-list',
                        code: x.tableName,
                        items: lookUpData.value.filter(t => t.id != props.dataSourceLookUp.idFieldDescription && t.dataSourceTableAliasId != null && t.tableName == x.tableName).map(t => ({
                            label: (t.shortDescription ?? t.field), tabla: t.tableName, value: t.tableName + DataSourceConst.DELIMITER + t.field, disabled: false,
                            command: (event: any) => {
                                selectedSearch.value = event.item.value
                                selectField(event)
                            }
                        })),
                        visible: true

                    }

                    data.push(aux);

                })

                fieldsData.value = data;
            }
        };


        const addFieldOnTheList = (field: IapDataSourceField) => {

            var newField = lookUpData.value.filter(t => t.id == field.id && t.dataSourceTableAliasId != null && t.tableName == field.tableName).map(t => ({
                label: (t.shortDescription ?? t.field), tabla: t.tableName, value: t.tableName + DataSourceConst.DELIMITER + t.field, disabled: false,
                command: (event: any) => {
                    selectedSearch.value = event.item.value
                    selectField(event)
                }
            }))

            var indexVar = fieldsData.value.findIndex(x => x.code == field.tableName);
            if (indexVar > -1) {
                fieldsData.value[indexVar].items.push(newField[0]);
            }
        }

        const removeFieldOnTheList = (field: IapDataSourceField) => {

            var indexVar = fieldsData.value.findIndex(x => x.code == field.tableName);

            if (indexVar > -1) {
                var indexItem = fieldsData.value[indexVar].items.findIndex(x => x.label == (field.shortDescription ?? field.field) && x.tabla == field.tableName);

                if (indexItem > -1) {
                    fieldsData.value[indexVar].items.splice(indexItem, 1);
                }

            }
        }



        const clearFilterData = () => {
            if (dataSearchFilter.value.length == 0) {
                initData()
            }
            else {
                dataSearchFilter.value.forEach(x => {
                    x.value = '',
                        x.rangeDateTime = {
                            from: null,
                            to: null
                        },
                        //x.filter = ,
                        x.rangeNumber = {
                            from: null,
                            to: null
                        },
                        x.rangeValue = {
                            from: null,
                            to: null
                        },
                        x.valueBool = undefined,
                        x.valueDateTime = undefined,
                        x.valueList = undefined,
                        x.valueNumber = undefined

                })
            }


        }

        const initData = () => {

            if (dataSearchFilter.value && dataSearchFilter.value.length == 0) {
                //const campos = ['NombreCompleto', 'NumDocumento']                
                const firstTabla = tables.value[0]?.tableName ?? ''
                lookUpData.value.filter(x => x.tableName.toLocaleLowerCase() == firstTabla.toLocaleLowerCase())
                    .forEach(c => {
                        dataSearchFilter.value.push({
                            field: c as any,
                            filter: FiltroBusquedaConst.FILTROBUSQUEDA_CONTIENE,
                        } as any)
                    })
            }

        }






        const fillDataSource = () => {

            if (props.container && props.dataSourceLookUp.dataSource.applicationId && props.dataSourceLookUp.dataSource.applicationVersion && props.dataSourceLookUp) {
                const _srv = props.container.get<IServiceSearch>(
                    TYPES.SEARCH_REPOSITORY
                );
                HelperLoading.showLoading();
                _srv.searchLookUp(props.dataSourceLookUp.dataSource.applicationId, props.dataSourceLookUp.dataSource.applicationVersion,
                    props.dataSourceLookUp.id, props.filterConditions, props.dataSourceLookUp?.maxRowsReturned ?? 5)
                    .then((response) => {


                        if (response) {
                            const { generateFormatCol } = DataSourceComp(props.container as any, props, emit, {}, {} as any, props.catalogsData, store, props.dataSourceLookUp.dataSource as any)
                            const obj = JSON.parse(response?.items ?? '[]');
                            generateFormatCol(obj)
                            HelperUtils.handleDates(obj)
                            rows.value = obj
                            getData();
                            fillDataSearchFilters();


                            initialColumns.value = initColumns();

                            //no mostramos de inicio el campo Id
                            selectedColumns.value = initialColumns.value.filter(x => x.field !== DataSourceConst.LOOKUPID);

                        }


                    })
                    .catch((err) => {

                    })
                    .finally(() => {

                        HelperLoading.hideLoading();
                    });

            }

        }

        const executeSearch = () => {


            let data = JSON.parse(JSON.stringify(dataSearchFilter.value));
            data = data.concat(props.filterConditions);
            if (props.container && props.dataSourceLookUp.dataSource.applicationId && props.dataSourceLookUp.dataSource.applicationVersion && props.dataSourceLookUp.id) {
                const _srv = props.container.get<IServiceSearch>(
                    TYPES.SEARCH_REPOSITORY
                );
                HelperLoading.showLoading();
                _srv.searchLookUp(props.dataSourceLookUp.dataSource.applicationId, props.dataSourceLookUp.dataSource.applicationVersion,
                    props.dataSourceLookUp.id, data as any ?? [], props.dataSourceLookUp?.maxRowsReturned ?? 5)
                    .then((response) => {


                        const { generateFormatCol } = DataSourceComp(props.container as any, props, emit, {}, {} as any, props.catalogsData, store, props.dataSourceLookUp.dataSource as any)
                        const obj = JSON.parse(response?.items ?? '[]');
                        generateFormatCol(obj)
                        HelperUtils.handleDates(obj)
                        rows.value = obj

                    })
                    .catch((err) => {

                    })
                    .finally(() => {

                        HelperLoading.hideLoading();
                    });

            }

        }

        const onToggle = (val: any) => {
            selectedColumns.value = initialColumns.value.filter(col => val.includes(col));
        };



        onMounted(() => {
            fillDataSource();

        })



        return {
            rows,
            onRowSelect,
            executeSearch,
            inputSearchId,
            inputSearchDesc,
            filters,
            ColumnName,
            dataSearchFilter,
            dataBase,
            tables,
            getCatalogData,
            CatalogTypeConst,
            isType,
            SqlTypesConst,
            isCatalogType,
            removeField,
            fieldsData,
            selectedSearch,
            selectField,
            clearFilterData,
            columns,
            DataSourceConst,
            initialColumns,
            selectedColumns,
            onToggle,
            FiltroBusquedaConst,
            orderColumns,
            stopPropagateEventDropDown
        };
    },
});
